
import  React from 'react';
import { X, Wand2 } from 'lucide-react';

const AuthModal = ({ isOpen, onClose }) => {
  if (!isOpen) {
    return null;
  }

  return (
    // The Modal Overlay
    <div
      onClick={onClose}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm transition-opacity duration-300 ease-in-out animate-fade-in"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      {/* The Modal Content */}
      <div
        onClick={(e) => e.stopPropagation()} // Prevents closing when clicking inside the modal
        className={`
          relative w-full max-w-sm transform rounded-2xl bg-dark-card border border-white/10 p-8 text-center shadow-2xl transition-all duration-300 ease-in-out
          ${isOpen ? 'scale-100 opacity-100' : 'scale-95 opacity-0'}
        `}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-dark-text-secondary/50 transition-colors hover:text-dark-text-primary"
          aria-label="Close modal"
        >
          <X size={20} />
        </button>

        {/* Icon */}
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-xl bg-gradient-to-br from-dark-accent-start/20 to-dark-accent-end/20">
            <Wand2 size={32} className="text-dark-accent-end" />
        </div>

        {/* Text Content */}
        <div className="mt-5">
          <h3 className="text-xl font-bold text-dark-text-primary" id="modal-title">
            Unlock Your AI Co-pilot
          </h3>
          <p className="mt-2 text-sm text-dark-text-secondary">
            Log in or create a free account to generate your first social media campaign.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="mt-8 flex flex-col space-y-3">
          <a
            href="https://app.oolook.in/"
            className="w-full rounded-lg bg-white/5 py-3 text-sm font-semibold text-dark-text-primary transition-colors hover:bg-white/10"
          >
            Log in
          </a>
          <a
            href="https://app.oolook.in/signup"
            className="w-full rounded-lg bg-white py-3 text-sm font-semibold text-black transition-colors hover:bg-gray-200"
          >
            Sign up
          </a>
        </div>
      </div>
    </div>
  );
};

export default AuthModal;